import React, { useEffect, useState } from 'react';
import DataTable from '../../../../../components/DataTable/DataTable';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const closedTransactionsTableColumns = [
  {
    id: 'name',
    label: <FormattedMessage id={'transactionLine.name'} />,
    align: 'left',
  },
  {
    id: 'quantity',
    label: <FormattedMessage id={'transactionLine.quantity'} />,
    align: 'right',
  },
  {
    id: 'unit_amount',
    label: <FormattedMessage id={'transactionLine.unitAmount'} />,
    align: 'right',
  },
  {
    id: 'amount',
    label: <FormattedMessage id={'transactionLine.amount'} />,
    align: 'right',
  },
];

const Items = ({ data }) => {
  const [internalData, setInternalData] = useState([]);
  useEffect(() => {
    if (data) {
      setInternalData(
        data.map((line) => {
          return {
            name: line.name,
            quantity:  <FormattedNumber value={parseFloat(line.quantity)} minimumFractionDigits={2} />,
            unit_amount: <><FormattedNumber value={parseFloat(line.unit_amount)} minimumFractionDigits={2} /> Kč</>,
            amount: <><FormattedNumber value={parseFloat(line.amount)} minimumFractionDigits={2} /> Kč</>,
          };
        }),
      );
    }
  }, [data]);

  return <DataTable
    columns={closedTransactionsTableColumns}
    data={internalData}
  />;
};

export default Items;
